import { z } from "zod";
import { SectionSpacingSchema } from "../../../../../zod/shared-schemas.mjs";
const FeatureSectionVideoTabsItemFeatureSchema = z.object({
  icon: z.string(),
  text: z.string().optional().nullable(),
  title: z.string(),
  iconMobile: z.string()
});
const FeatureSectionVideoTabsItemSchema = z.object({
  name: z.string().optional().nullable(),
  text: z.string().optional().nullable(),
  image: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  video: z.string().optional().nullable(),
  button: z.object({
    text: z.string(),
    isVisible: z.boolean().optional().nullable(),
    isVideoOpener: z.boolean().optional().nullable(),
    link: z.string().optional().nullable(),
    target: z.string().optional().nullable()
  }),
  videoId: z.string().optional().nullable(),
  features: FeatureSectionVideoTabsItemFeatureSchema.array(),
  featuresText: z.string().optional().nullable()
});
const FeatureSectionVideoTabsSchema = z.object({
  id: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  text: z.string().optional().nullable(),
  slides: FeatureSectionVideoTabsItemSchema.array()
}).merge(SectionSpacingSchema);
export default FeatureSectionVideoTabsSchema;
